export default __webpack_public_path__ + "static/media/mail.f0a1b82a.svg";